import React, { useEffect } from 'react';
import '../../App.css';
import Footer from '../Footer';
import HomeGallery from '../HomeGallery';


function PortfolioEvents() {
    useEffect(() => {
            const timer = setTimeout(() => {
                window.scrollTo({ top: window.innerHeight * 0.75, behavior: 'smooth' });
                }, 50);
    
            return () => clearTimeout(timer);
    }, []);
        
  return (
    <>
        <h1 className='portfolio-hero'>Portfolio</h1>

        <h1 className='text'>Events</h1>

        <HomeGallery images={['/images/img-events-1.jpg','/images/img-events-2.jpg','/images/img-events-3.jpg','/images/img-events-4.jpg','/images/img-events-5.jpg','/images/img-events-6.jpg']} />

        <Footer />
    </>
  )
}

export default PortfolioEvents
